import React, { useContext } from 'react';
import { MetricsContainer } from 'components/BoardSlideOut/Metrics';
import usePerformanceSlideOutFilterInput from 'components/PerformanceBoards/hooks/usePerformanceSlideOutFilterInput';
import useSlideoutDateScope from 'components/PerformanceBoards/hooks/useSlideoutDateScope';
import PerformanceBoardSlideOutContext from 'components/PerformanceBoards/contexts/PerformanceBoardSlideOutContext';
import EditingSectionWrapperDiv from '../EditingSectionWrapperDiv';

const MetricContainer = ({
  section,
}: {
  section: PerformanceBoardTypes.SlideOut.MetricsSection;
}) => {
  const filterInput = usePerformanceSlideOutFilterInput({});
  const dateScope = useSlideoutDateScope(section.dateRange);

  const { navState } = useContext(PerformanceBoardSlideOutContext);

  if (!filterInput || !dateScope) {
    return null;
  }

  if (navState.slideoutMode === 'Creating' || navState.editingSection) {
    return (
      <EditingSectionWrapperDiv>
        <MetricsContainer
          filterInput={filterInput}
          dateScope={dateScope}
          metricIds={section.metricIds}
          title={section.title}
        />
      </EditingSectionWrapperDiv>
    );
  }

  return (
    <MetricsContainer
      filterInput={filterInput}
      dateScope={dateScope}
      metricIds={section.metricIds}
      title={section.title}
      homeViz
    />
  );
};

export default MetricContainer;
